import { JoinEventRes } from 'src/services/types/joinEventV2'
import { ILoginUser } from './../../../services/types/user'

export enum TrackedEvents {
    LOGIN = 'Login',
    PRODUCT_VIEWED = 'Product Viewed',
    SEARCH = 'Search',
    PRODUCT_ADDED = 'Product Added',
    PRODUCT_REMOVED = 'Product Removed',
    ORDER_COMPLETE = 'Order Completed',
    ORDER_UPDATE = 'Order Updated',
    ORDER_CANCEL = 'Order Cancelled',
    REGISTRATION = 'Register',
    REFERRAL = 'Referral',
    CART_VIEWED = 'Cart Viewed',
    CHECKOUT_STARTED = 'Checkout Started'
}
export interface Address {
    city: string
    country: string
    postalCode: string
    state: string
    street: string
}
export interface Company {
    name: string
    id: number
    industry: string
    employee_count: number
    plan: string
}
export interface Traits {
    address: Address
    avatar: string
    birthday: Date
    company?: Company
    createdAt: Date
    description?: string
    email: string
    firstName: string
    gender: string
    id: string
    lastName?: string
    name: string
    phone?: string
    title?: string
    username: string
    website?: string
    fb_login_id: string
}
export enum Gender {
    'male',
    'female'
}

export interface ViewEventProps {
    productData: JoinEventRes
    user?: ILoginUser
}
export interface SegementProperties {
    revenue?: number
    currency?: string
    value?: number
}

export interface Order {
    checkout_id?: string
    order_id: string
    affiliation: string
    total: number
    subtotal: number
    revenue: number
    shipping?: number
    tax?: number
    discount: number
    coupon: string
    currency: string
    products: Product[]
}

export interface Product {
    product_id: number
    sku: string
    name: string
    price: number
    quantity: number
    category: string
    brand?: string
    remarketing?: Remarketing
}

export interface Remarketing {
    dynx_itemid: number
    dynx_itemid2: string
    dynx_pagetype: string
    dynx_totalvalue: number
}
export interface RemarketingV2 {
    id: number
    google_business_vertical: string
}

export enum GoogleBusinessVertical {
    Retail = 'retail'
}

export enum Category {
    VirtualRace = 'Virtual Race',
    Exercise = 'Exercise',
    FitnessChallenge = 'Fitness Challenge',
    Store = 'Store',
    Trainers = 'Trainers',
    Blog = 'Blog',
    Cart = 'Cart',
    Misc = 'Misc'
}

export enum EventType {
    Races = 'Races',
    Store = 'Store',
    Challenges = 'Challenges',
    Exercises = 'Exercises'
}

export const EventTypeInt = {
    1: 'Virtual Race',
    2: 'Store',
    3: 'Fitness Challenge',
    4: 'Exercises'
}

export const ProductCategoryByEventType = {
    'Virtual Race': EventType.Races,
    'Fitness Challenge': EventType.Challenges,
    Store: EventType.Store,
    Exercises: EventType.Exercises
}

export enum GTMEvents {
    AddToCart = 'add_to_cart',
    RemoveFromCart = 'remove_from_cart',
    Purchase = 'purchase',
    ViewItem = 'view_item'
}
